import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Tab } from "react-bootstrap";

import { mySimsApi } from "../../../utility/api/apiList";

import userMessageType from "../../../redux/actions/userMessage/userMessageType";

import useFilter from "../../../hooks/useFilter";
import useAxios from "../../../hooks/useAxios";

import ExperimentTabComponent from "../../../components/private/user/userExperiment";
import UserTabsComponent from "../../../components/private/tabs";

const UserExperimentContainer = () => {
  const { onChange, filterState } = useFilter();
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = "آزمایش‌ها";
  }, []);

  const {
    data: myOwnSimsData,
    run: runGetMyOwnSims,
    isLoading,
    error,
  } = useAxios({
    url: mySimsApi,
    params: {
      page_size: process.env.REACT_APP_PROFILE_PAGE_SIZE,
      page: filterState["page"] || 1,
    },
  });

  useEffect(() => {
    dispatch({ type: userMessageType.UPDATE_COUNT_UNREAD_MESSAGE });
    runGetMyOwnSims();
  }, []);

  const productDetail = useSelector((state) => state.productDetail);
  const myOwnSimsDetail = {
    product: myOwnSimsData,
    loading: isLoading,
    error: Boolean(error),
    errorMessage: error,
  };

  return (
    <UserTabsComponent
      defaultActiveKey={filterState["tab"]}
      onSelect={(k) => {
        onChange("tab", k);
      }}
    >
      <Tab eventKey="my_sims" title="آزمایش‌های من">
        {(filterState["tab"] === "my_sims" || !filterState["tab"]) && (
          <ExperimentTabComponent
            productDetail={myOwnSimsDetail}
            getSimsMethod={runGetMyOwnSims}
          />
        )}
      </Tab>
      <Tab eventKey="my_favourite" title="علاقه‌مندی‌های من">
        {filterState["tab"] === "my_favourite" && (
          <ExperimentTabComponent
            productDetail={productDetail}
            filterParams="my_bookmarked_sim=True"
          />
        )}
      </Tab>
    </UserTabsComponent>
  );
};

export default UserExperimentContainer;
